import { apiClient, getActivePvzId, isSupabaseConfigured } from './_shared.js'

// ============================================
// MANAGEMENT ACCOUNTING (P&L)
// ============================================

export async function getWbIncomes(pvzId, periodStart, periodEnd) {
  if (!isSupabaseConfigured) return []
  const params = new URLSearchParams()
  if (pvzId) params.append('pvzId', pvzId)
  if (periodStart) params.append('periodStart', periodStart)
  if (periodEnd) params.append('periodEnd', periodEnd)
  const data = await apiClient('/incomes?' + params.toString())
  return data.map(item => ({ ...item, period_start: item.period_start?.split('T')[0], period_end: item.period_end?.split('T')[0], date: item.date?.split('T')[0] }))
}

function cleanNumber(val) {
  if (val === null || val === undefined || val === '') return 0
  if (typeof val === 'number') return val
  const cleaned = val.toString().replace(/[^0-9.-]/g, '')
  return parseFloat(cleaned) || 0
}

export async function addWbIncome(incomeData, pvzId) {
  if (!isSupabaseConfigured) return null
  const targetPvzId = pvzId || getActivePvzId()
  if (!targetPvzId) throw new Error('Не выбран ПВЗ')

  const periodStart = incomeData.period_start || new Date().toISOString().split('T')[0]
  const periodEnd = incomeData.period_end || periodStart

  const cleanedData = {
    pvz_id: targetPvzId,
    period_start: periodStart,
    period_end: periodEnd,
    date: periodStart,
    amount: cleanNumber(incomeData.amount),
    compensation: cleanNumber(incomeData.compensation),
    bonus: cleanNumber(incomeData.bonus),
    penalty: cleanNumber(incomeData.penalty),
    comment: incomeData.comment || null,
    source: incomeData.source || 'Wildberries'
  }

  return await apiClient('/incomes', {
    method: 'POST',
    body: JSON.stringify(cleanedData)
  })
}

export async function updateWbIncome(id, incomeData) {
  if (!isSupabaseConfigured) return null
  const updates = {}
  if (incomeData.period_start) {
    updates.period_start = incomeData.period_start
    updates.date = incomeData.period_start
  }
  if (incomeData.period_end) updates.period_end = incomeData.period_end
  if (incomeData.amount !== undefined) updates.amount = cleanNumber(incomeData.amount)
  if (incomeData.compensation !== undefined) updates.compensation = cleanNumber(incomeData.compensation)
  if (incomeData.bonus !== undefined) updates.bonus = cleanNumber(incomeData.bonus)
  if (incomeData.penalty !== undefined) updates.penalty = cleanNumber(incomeData.penalty)
  if (incomeData.comment !== undefined) updates.comment = incomeData.comment || null
  if (incomeData.source !== undefined) updates.source = incomeData.source || 'Wildberries'
  if (incomeData.is_received !== undefined) updates.is_received = !!incomeData.is_received

  return await apiClient(`/incomes/${id}`, {
    method: 'PUT',
    body: JSON.stringify(updates)
  })
}

export async function deleteWbIncome(id) {
  if (!isSupabaseConfigured) return null
  return await apiClient(`/incomes/${id}`, { method: 'DELETE' })
}

export async function getExpenses(pvzId, periodStart, periodEnd) {
  if (!isSupabaseConfigured) return []
  
  const params = new URLSearchParams()
  if (pvzId) params.append('pvzId', pvzId)
  if (periodStart) params.append('periodStart', periodStart)
  if (periodEnd) params.append('periodEnd', periodEnd)

  let data = await apiClient('/expenses?' + params.toString())
  data = data.map(item => ({ ...item, date: item.date?.split('T')[0] }))
  return data
}

export async function addExpense(expenseData, pvzId) {
  if (!isSupabaseConfigured) return null
  const targetPvzId = pvzId || getActivePvzId()
  if (!targetPvzId) throw new Error('Не выбран ПВЗ')
  return await apiClient('/expenses', {
    method: 'POST',
    body: JSON.stringify({ ...expenseData, pvz_id: targetPvzId })
  })
}

export async function updateExpense(id, expenseData) {
  if (!isSupabaseConfigured) return null
  return await apiClient(`/expenses/${id}`, {
    method: 'PUT',
    body: JSON.stringify(expenseData)
  })
}

export async function deleteExpense(id) {
  if (!isSupabaseConfigured) return null
  return await apiClient(`/expenses/${id}`, { method: 'DELETE' })
}

export async function bulkAddIncomes(rows) {
  if (!isSupabaseConfigured) return null
  return await apiClient('/incomes/bulk', {
    method: 'POST',
    body: JSON.stringify({ rows })
  })
}



export async function bulkAddExpenses(rows) {
  if (!isSupabaseConfigured) return null
  return await apiClient('/expenses/bulk', {
    method: 'POST',
    body: JSON.stringify({ rows })
  })
}
